<template>
  <div>
    <v-container class="pl-10">
      <Home></Home>
    </v-container>
    <PageLoadingProgress ref="PageLoadingProgress"></PageLoadingProgress>
  </div>
</template>
<style scoped>
.container {
  max-width: 100%;
}
</style>
<script>
const Home = () =>
  import(
    /* webpackChunkName: "ViewHome" */ "@/components/membership/home/Home.vue"
  );

import PageLoadingProgress from "@/components/common/PageLoadingProgress.vue";

export default {
  mounted: function() {
    this.progressShow();
  },

  methods: {
    progressShow: function() {
      this.$refs.PageLoadingProgress.show();
    },
    progressHide: function() {
      this.$refs.PageLoadingProgress.hide();
    },
  },
  components: {
    Home,
    PageLoadingProgress,
  },
};
</script>
